import React from "react";
import { Box, Heading } from "@chakra-ui/layout";

import icon from "assets/cherryhub_logo.svg";
import xmasIcon from "assets/cherryhub_logo_xmas.svg";
import { Image } from "@chakra-ui/image";
import { useLayoutContext } from "../../context/LayoutContext";

export const AppTitle = () => {
  const { isDesktop } = useLayoutContext();
  const isDecember = new Date().getMonth() === 11;
  return (
    <Box flexShrink={1}>
      <Heading
        as="span"
        ml={isDesktop ? "8" : "2"}
        fontSize="20px"
        lineHeight="20px"
        color="#fff"
      >
        {isDesktop && (
          <Box display="inline-block" w="100px" h="20px" textAlign="center">
            <Image
              src={isDecember ? xmasIcon : icon}
              w="80px"
              h="80px"
              position="absolute"
              alt="Cherryhub icon"
              zIndex="2"
              borderRadius="full"
              shadow="lg"
            />
          </Box>
        )}
        {!isDesktop && <>Cherry Hub Portal</>}
      </Heading>
    </Box>
  );
};
